import { render, staticRenderFns } from "./CompleteUserAccountView.vue?vue&type=template&id=1bb6eda8"
import script from "./CompleteUserAccountView.vue?vue&type=script&lang=js"
export * from "./CompleteUserAccountView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports